
export default {
  model: {
    event: ['change'],
  },

  props: {
    value: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      count: 0,
    }
  },

  computed: {
    isMin() {
      return this.count === this.min
    },
  },

  watch: {
    count() {
      this.$emit('update:value', this.count)
      this.$emit('change', this.count)
    },
  },

  created() {
    this.count = this.value
  },

  methods: {
    /**
     * @description: Get disable class.
     * @param {*}
     * @return {*}
     */
    disableClass(value) {
      return {
        disabled: value,
      }
    },
    /**
     * @description: Handle minus.
     * @param {*}
     * @return {*}
     */
    handleMinus() {
      if (this.isMin) {
        return
      }

      this.count -= this.step
    },
    /**
     * @description: Handle plus.
     * @param {*}
     * @return {*}
     */
    handlePlus() {
      this.count += this.step
    },
  },
}
